import { apiClient, Auth } from '@/shared/api'
import { action } from '@/shared/config'

import { TRequestContractResponse, ZRequestContract } from './schema'

export const requestContract = action
  .metadata({
    actionName: 'requestContractAction',
  })
  .schema(ZRequestContract)
  .action(async ({ parsedInput: body }) => {
    const response = await apiClient.post<TRequestContractResponse>({
      endpoint: '/guest/contracts/request',
      body,
      auth: Auth.REQUIRED,
    })

    return response
  })
